import React, { useContext, useRef, useState, useEffect } from "react";
import "../AddEventModal/AddEventModal.css";
import { IoCloseOutline, IoDocumentTextOutline } from "react-icons/io5";
import { useLanguage } from "../../../../LanguageProvider";
import { useToaster } from "../../../../ToasterProvider";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import DatePicker from "../../../../components/DatePicker/DatePicker";
import TimePicker from "../../../../components/TimePicker/TimePicker";
import Dropdown from "../../../../components/Dropdown/Dropdown";
import Services from "../../../../services/Services";
import { GeneralContext } from "../../../../GeneralProvider";
import { RiTwitterXFill } from "react-icons/ri";

export default function AddTicketModal({
    isOpen,
    onClose,
    channelID,
    eventID,
    getEventDetails,
    tickets,
    getEvents
}) {
    const { toastError, toastSuccess } = useToaster();
    const { getTranslation } = useLanguage()
    const [trackInventory, setTrackInventory] = useState(false);
    const token = localStorage.getItem("token")

    const [title, setTitle] = useState("");
    const [type, setType] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState("");
    const [inventory, setInventory] = useState("");

    if (!isOpen) return null;

    const resetStates = () => {
        setTrackInventory(false)
        setTitle("")
        setType("")
        setDescription("")
        setPrice("")
        setInventory("")
    }

    const addTicket = () => {
        const ticket = {
            title,
            type,
            description,
            price: parseFloat(price),
            currency: "TRY",
            trackInventory,
            inventory: trackInventory ? parseInt(inventory, 10) : null
        };

        // isFree hesaplama logu
        const currentTickets = [...tickets, ticket]; // ileride çoklu destek olursa buraya mevcut ticket listesi gelebilir

        const isFree = currentTickets.every(t => Number(t.price) === 0)
            ? "1"
            : currentTickets.every(t => Number(t.price) > 0)
                ? "2"
                : "3";

        Services.SocialHiveAddTicketToEvent(
            token,
            channelID,
            eventID,
            ticket.title,
            ticket.type,
            ticket.description,
            ticket.price,
            ticket.currency,
            ticket.trackInventory,
            ticket.trackInventory ? ticket.inventory : ""
        )
            .then((res) => {
                if (res.data.status) {
                    toastSuccess(getTranslation("successMessage"));
                    getEventDetails();
                    onClose();
                    resetStates();

                    Services.SocialHiveUpdateEvent(token, { channelID, eventID, isFree })
                        .then((res) => {
                            getEvents()
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                } else {
                    toastError(getTranslation("somethingWentWrong"));
                }
            })
            .catch((err) => {
                console.error(err);
                toastError(getTranslation("somethingWentWrong"));
            });
    };

    return (
        <div className="add-event-modal-overlay">
            <div className="add-event-modal-container">
                <IoCloseOutline
                    className="add-event-modal-button close"
                    onClick={() => { onClose(); resetStates(); }}
                />

                <p className="add-event-modal-title">{getTranslation("addTicketType")}</p>

                <div style={{ gap: '15px', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ width: '100%', flexDirection: 'row', display: 'flex', justifyContent: 'space-between', marginTop: '15px' }}>
                        <Dropdown
                            style={{ width: "120px" }}
                            options={[{ value: "TRY", label: "TRY" }]}
                            value={"TRY"}
                        />
                    </div>

                    <AddModalInputField value={title} onChange={e => setTitle(e.target.value)} placeholder={getTranslation("title") + "*"} />

                    <AddModalInputField value={type} onChange={e => setType(e.target.value)} placeholder={getTranslation("type") + "*"} />

                    <div className="add-task-modal-content">
                        <IoDocumentTextOutline
                            size={20}
                            style={{
                                width: "25px",
                                alignSelf: "flex-start",
                                marginTop: "10px",
                            }}
                        />
                        <textarea
                            value={description} onChange={e => setDescription(e.target.value)}
                            style={{ height: '150px' }}
                            className="add-task-modal-textarea"
                            placeholder={getTranslation("description") + "*"} />
                    </div>

                    <AddModalInputField value={price}
                        onChange={e => {
                            const val = e.target.value;
                            if (val === "" || Number(val) >= 0) {
                                setPrice(val);
                            }
                        }}
                        type="number"
                        placeholder={getTranslation("price") + "*"} />

                    <span
                        onClick={() => setTrackInventory(!trackInventory)}
                        className="add-channel-modal-title"
                        style={{
                            alignItems: "center",
                            gap: "15px",
                            display: "flex",
                            flexDirection: "row",
                            fontWeight: "500",
                            fontSize: "14px",
                        }}
                    >
                        <input type="checkbox" checked={trackInventory} /> {getTranslation("trackInventory")}
                    </span>

                    <div style={{ marginBottom: '15px' }}>
                        {trackInventory &&
                            <AddModalInputField
                                value={inventory}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === "" || (/^\d+$/.test(val) && Number(val) >= 0)) {
                                        setInventory(val);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (["-", "e", ".", ","].includes(e.key)) {
                                        e.preventDefault(); // bu karakterleri tamamen engelle
                                    }
                                }}
                                type="text"
                                placeholder={getTranslation("inventory") + "*"} />
                        }
                    </div>
                </div>

                <button
                    onClick={addTicket}
                    className="add-event-modal-button create"
                >
                    {getTranslation("create")}
                </button>

            </div>
        </div>
    );
}
